/* eslint-disable prettier/prettier */
import React from 'react';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import { Paper } from '@material-ui/core';

import { Captions, LongBody, SmallSectionHeader } from 'components/Typography';
import breakpoints from 'utils/breakpoints';


const StyledBox = styled(({ isRadiusTop, ...otherProps }) => (
  <Box {...otherProps} />
))`
  border: 1px solid #e3e3e3;
  border-radius: ${(props) =>
    props.isRadiusTop ? '10px 10px 0 0' : '0px 0px 10px 10px'};
  border-top: ${(props) => (props.isRadiusTop ? '1px solid #E3E3E3' : 'none')};
`;

const GeneralConditions = styled.a`
  color: #1974fe;
  text-decoration: underline;
  cursor: pointer;
`;

const MemoIdBox = styled(Box)`
  p {
    margin: 0;
  }
`;


const StyledCaptions = styled(Captions)`
  margin-bottom: 0px !important;
`;

const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  margin-bottom: 0px !important;
  @media (max-width: ${breakpoints.xs}) {
    margin-top: -16px !important;
  }
`;

const StyledLongBody = styled(LongBody)`
  margin-bottom: 0px !important;
  @media (max-width: ${breakpoints.xs}) {
    font-size: 14px !important;
  }
`;

const StyledPaper = styled(Paper)`
 height : 500px !important;
 overflow: auto;
 box-shadow : none !important;

`;
const StyledBodyText = styled.p`
white-space: pre-line;
color: #162952;
font-size: 13px;
letter-spacing: 0;
line-height: 20px;
max-height: 500px;
margin: 0px;
overflow: auto;
`;


const SizedLongBody = styled(LongBody)`
  && {
    margin-bottom: 0px;
  }
`;

export {
  SizedLongBody,
  StyledBox,
  GeneralConditions,
  MemoIdBox,
  StyledCaptions,
  StyledSmallSectionHeader,
  StyledPaper,
  StyledBodyText,
  StyledLongBody
};
